import { ChangeEvent } from "react";

interface NumberSelectorProps {
  value: number;
  setValue: (value: number) => void;
  maxNumber: number;
}

const NumberSelector: React.FC<NumberSelectorProps> = (props) => {
  const { value, setValue, maxNumber } = props;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let val = parseInt(event.target.value, 10);
    if (maxNumber === 0) {
      return;
    }

    if (isNaN(val) || val < 1 || val > maxNumber) {
      val = 1;
    }
    setValue(val);
  };

  return (
    <div className="flex h-8 bg-gray-100 rounded-full max-w-[100px]">
      <button
        className="bg-gray-200 size-8 rounded-full flex-1 border-2 hover:border-icon"
        onClick={() => {
          if (value > 1) {
            setValue(value - 1);
          }
        }}
      >
        -
      </button>
      <input
        className="flex-1 w-8 bg-transparent hide-arrows text-center outline-none"
        type="number"
        value={value}
        onChange={handleChange}
      />
      <button
        className="bg-gray-200 size-8 rounded-full flex-1 border-2 hover:border-icon"
        onClick={() => {
          if (value < maxNumber) {
            setValue(value + 1);
          }
        }}
      >
        +
      </button>
    </div>
  );
};

export default NumberSelector;
